import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@authentication/services/auth.service';

export const noStudentRoleGuard = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
	const authService = inject(AuthService);
	if (authService.hasStudentRole()) {
		authService.navigateAfterLogin();
		return false;
	}
	return true;
};
